import $ from 'jquery';

export class ConfigProvider {
    private static instance: ConfigProvider;
    private static FILE_CONFIG_PATH = "/config.json";
    private static FILE_DEV_CONFIG_PATH = "/config-dev.json";
    private configuration: object | undefined = undefined;

    public static getInstance(): ConfigProvider {
        if (!ConfigProvider.instance) {
            ConfigProvider.instance = new ConfigProvider();
        }

        return ConfigProvider.instance;
    }

    loadConfiguration(callback?: any, errorCallback?: any){
        console.log("[ConfigProvider] Load configuration!");
        let filePath = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')? ConfigProvider.FILE_DEV_CONFIG_PATH : ConfigProvider.FILE_CONFIG_PATH;
        $.getJSON(filePath + '?timestamp=' + new Date().getTime(), (obj) => {
            if (/(stg|mpos|posweb)/i.test(window.location.hostname)) {
                obj.loginApi = window.location.origin + '/api/oauth/v2/token';
                obj.baseApi = window.location.origin + '/api/services';
            }
            this.configuration = obj;
            console.log("Configuration successfully loaded!");
            if(typeof callback !== 'undefined'){
                callback(obj);
            }
        }).fail(() => {
            console.log("Configuration error loading!");
            if(typeof errorCallback !== 'undefined'){
                errorCallback();
            }
        });
    }

    getConfiguration(): object {
        if(this.configuration === undefined){
            throw new Error("Configuration not loaded!");
        } else {
            return this.configuration;
        }
    }
}